export default "__VITE_ASSET__4cbad9a4__"